import { IconButton, Snackbar, SnackbarContent, withStyles } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'classnames';
import React, { useCallback } from 'react';
import { DEFAULT_NOTIFICATION_TIMEOUT } from '../../features/hooks/useNotification';
import styles from './styles';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    info: InfoIcon,
    error: ErrorIcon,
};

function NotificationComponent(props) {
    const { notifications, onClose } = props;

    const handleClose = useCallback((notificationId) => () => onClose(notificationId), [onClose]);

    function getIcon(type) {
        const Icon = variantIcon[type];

        return <Icon className={classNames(props.classes.icon, props.classes.iconVariant)} />;
    }

    return notifications.map((notification) => (
        <Snackbar
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            autoHideDuration={DEFAULT_NOTIFICATION_TIMEOUT}
            open={true}
            key={notification.id}
        >
            <SnackbarContent
                className={props.classes[notification.type]}
                aria-describedby="client-snackbar"
                message={
                    <span id="client-snackbar" className={props.classes.message}>
                        {getIcon(notification.type)}
                        {notification.message}
                    </span>
                }
                action={[
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className={props.classes.close}
                        onClick={handleClose(notification.id)}
                    >
                        <CloseIcon className={props.classes.icon} />
                    </IconButton>,
                ]}
            />
        </Snackbar>
    ));
}

export default withStyles(styles)(NotificationComponent);
